import * as commonConsts from '../../../../pages/common/CommonConsts';
import {
  validate,
  scrollToError,
  isValidEmail,
  isAustralianPhoneNumberWithCountryCodeOrNull,
  isAustralianPhoneNumberWithOutCountryCodeOrNull
} from '../../../../utils/Validation';

const getValidatorsIndividualAuthorityHolder = (props) => [
  {
    fieldName: 'emailAddress',
    fieldValue: props.emailAddress,
    isValid: (v) => isValidEmail(v)
  },
  {
    fieldName: 'mobileNumber',
    fieldValue: props.primaryContactNumber,
    isValid: (v) => {
      return !!!isAustralianPhoneNumberWithOutCountryCodeOrNull(v);
    }
  },
  {
    fieldName: 'secondaryContactPrefix',
    fieldValue: props.secondaryContactNumber?.prefix,
    isValid: (v) => {
      if (v === null && props.secondaryContactNumber?.number === null) {
        return true;
      }

      if (v === '') {
        return false;
      }

      if (Array.isArray(v)) {
        return false;
      }

      const validPrefix = commonConsts.australianPhonePrefixes.find((x) => x === v);
      if (validPrefix) {
        return true;
      } else {
        return false;
      }
    }
  },
  {
    fieldName: 'secondaryContactNumber',
    fieldValue: props.secondaryContactNumber?.number,
    isValid: (v) => {
      if (props.secondaryContactNumber?.prefix === null && v === null) {
        return true;
      }

      if (v === null) {
        return false;
      }

      if (props.secondaryContactNumber.prefix === commonConsts.australianCountryCode) {
        return isAustralianPhoneNumberWithCountryCodeOrNull(v);
      }

      if (props.secondaryContactNumber.prefix !== commonConsts.australianCountryCode) {
        return isAustralianPhoneNumberWithOutCountryCodeOrNull(v);
      }
    }
  },
  {
    fieldName: 'firstAddress',
    fieldValue: {
      sameAsFirstAddress: props.sameAsResidentialFlag,
      addressResidential: props.residentialAddress,
      addressPostal: props.postalAddress,
      addressResidentialPlaceholder: props.residentialAddressPlaceholder,
      addressPostalPlaceholder: props.postalAddressPlaceholder,
      residentialAddressValid: props.residentialAddressValid
    },
    isValid: (v) => {
      const result =
        v.residentialAddressValid ||
        ((!!!v.addressResidential?.lookupValue || !!!v.addressResidential?.enterManually) &&
          !!v.addressResidentialPlaceholder);
      return result;
    }
  },
  {
    fieldName: 'secondAddress',
    fieldValue: {
      sameAsFirstAddress: props.sameAsResidentialFlag,
      addressResidential: props.residentialAddress,
      addressPostal: props.postalAddress,
      addressResidentialPlaceholder: props.residentialAddressPlaceholder,
      addressPostalPlaceholder: props.postalAddressPlaceholder,
      residentialAddressValid: props.residentialAddressValid,
      postalAddressValid: props.postalAddressValid
    },
    isValid: (v) => {
      let result;
      if (v.sameAsFirstAddress) {
        result =
          v.postalAddressValid ||
          ((!!!v.addressResidential?.lookupValue || !!!v.addressResidential?.enterManually) &&
            !!v.addressResidentialPlaceholder);
        return result;
      }

      result =
        v.postalAddressValid ||
        ((!!!v.addressPostal?.lookupValue || !!!v.addressPostal?.enterManually) && !!v.addressPostalPlaceholder);
      return result;
    }
  }
];

const errorsDefaultValue = {
  emailAddress: false,
  mobileNumber: false,
  secondaryContactPrefix: false,
  secondaryContactNumber: false,
  firstAddress: false,
  secondAddress: false
};

export { getValidatorsIndividualAuthorityHolder, errorsDefaultValue };
